'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponIndices, useCouponPrice } from '@svs/nova-poolbetting/core/nextjs/coupon';
import type { CouponIndex } from '@svs/nova-poolbetting/schema/coupon';
import { CouponSelection } from '@svs/nova-poolbetting/ui/Coupon';
import { TipsenLink } from '@svs/nova-poolbetting/ui/TipsenLink';
import { TabLink, TabLinks } from '@svs/ui/react/tabs-links';
import { type ReactNode } from 'react';
function CouponSelectionContainer(t0) {
  const $ = _c(23);
  const {
    couponIndex
  } = t0;
  const [couponId, selectedCouponIndex] = useCouponId();
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const couponIndices = useCouponIndices(t1);
  let t2;
  if ($[2] !== couponId || $[3] !== couponIndex) {
    t2 = {
      couponId,
      couponIndex
    };
    $[2] = couponId;
    $[3] = couponIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const price = useCouponPrice(t2);
  const isSelectedCoupon = selectedCouponIndex === couponIndex;
  let t3;
  if ($[5] !== couponIndex) {
    t3 = {
      name: "delete",
      type: "submit",
      form: "coupon_form",
      value: couponIndex,
      "aria-label": "Ta bort kupong"
    };
    $[5] = couponIndex;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== couponIndex) {
    t4 = {
      query: {
        coupon: couponIndex
      }
    };
    $[7] = couponIndex;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `${couponIndex + 1}`;
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="sr-only">Kupong {t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== couponIndex || $[12] !== couponIndices.length || $[13] !== price) {
    t7 = <CouponSelection price={price} couponIndex={couponIndex} numberOfCoupons={couponIndices.length} />;
    $[11] = couponIndex;
    $[12] = couponIndices.length;
    $[13] = price;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <TipsenLink href={t4} scroll={false} queriesToKeep="ALL">{t6}{t7}</TipsenLink>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isSelectedCoupon || $[20] !== t3 || $[21] !== t8) {
    t9 = <TabLink isActive={isSelectedCoupon} closeButtonProps={t3} asChild={true}>{t8}</TabLink>;
    $[19] = isSelectedCoupon;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}

/**
 * Coupon Selection Container for smaller device.
 *
 * @returns CouponSelectionContainer component
 */
// eslint-disable-next-line react/no-multi-comp
export default function CouponsSelectionContainer() {
  const $ = _c(6);
  const [couponId] = useCouponId();
  let t0;
  if ($[0] !== couponId) {
    t0 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const couponIndices = useCouponIndices(t0);
  if (couponIndices.length <= 1) {
    return;
  }
  let t1;
  if ($[2] !== couponIndices) {
    t1 = couponIndices.map(_temp);
    $[2] = couponIndices;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <TabLinks alignment="left" context="surface" className="rounded-b-none px-1 lg:hidden">{t1}</TabLinks>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(index) {
  return <CouponSelectionContainer key={index} couponIndex={index} />;
}